// The component registry — 05j-1. modules.json's `renderer` name → the widget's React mount
// (bridge.tsx's registerReactModule fills it, modules/index.ts lists them). The shell's
// refreshModuleBody renders through it. Until 05j-1 the shell called window[renderer] and
// each registration overwrote the legacy window.render*Module. (The legacy renderer files
// were deleted in 05k-2.)
//
// Its own file (not bridge.tsx) so the shell can use it without an import cycle — the
// bridge imports the shell.

import type { ModuleConfig } from "./module-config-rules.js";
import type { PlayerId } from "../data/players.js";

/** `playerId`: the module's player (its `.player-select`), or null without one. */
export type ModuleRenderer = (body: HTMLElement, playerId: PlayerId | null, modCfg: ModuleConfig) => void;

const renderers = new Map<string, ModuleRenderer>();

export function registerRenderer(name: string, render: ModuleRenderer): void {
  renderers.set(name, render);
}

/** The mount for a modules.json renderer name. Throws for one nobody registered — every
 *  widget in modules.json has a React module, so that's a bug, not a legacy fallback. */
export function rendererFor(name: string): ModuleRenderer {
  const render = renderers.get(name);
  if (!render) throw new Error(`No React module registered for renderer "${name}" (modules/index.ts)`);
  return render;
}

/** Is this renderer name registered? (A type switch checks its target.) */
export function hasRenderer(name: string): boolean {
  return renderers.has(name);
}
